import styled from "@emotion/styled";
import { DatePicker } from "antd";
import { useRef } from "react";
import styles from "./styles.module.scss";
import bg from "../../images/year-picker.png";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import locale from "antd/es/date-picker/locale/zh_CN";

const { RangePicker } = DatePicker;
type Props = {
  defaultValue?: number | string;
  defaultValues?: [string, string];
  style?: React.CSSProperties;
  placeholder?: string;
  onChange?: (day: dayjs.Dayjs | null, dateString: string) => void;
  picker?: React.ComponentProps<typeof DatePicker>["picker"];
  format?: React.ComponentProps<typeof DatePicker>["format"];
  isRange?: boolean;
};

const PickerLayout = styled.div`
  margin-left: 10px;
  .ant-picker {
    background-color: transparent;
    background-image: url(${bg});
    border: none !important;
    background-repeat: no-repeat;
    background-size: cover;
    /* border-radius: 20px; */
    color: #fff;
    .ant-picker-input > input {
      color: #fff;
      &::placeholder {
        color: #ddd;
      }
    }
    .ant-picker-suffix {
      color: #fff;
    }
  }
  .ant-picker-dropdown {
    z-index: 1111112222222 !important;
  }
`;

const YearPicker: React.FC<Props> = ({
  defaultValue = new Date().getFullYear().toString(),
  defaultValues = ["2022", "2023"],
  style = {},
  placeholder,
  onChange,
  picker = "year",
  format,
  isRange = false,
}) => {
  const box = useRef<HTMLDivElement | null>(null);
  const pickerProps = !format
    ? {
        picker,
      }
    : {
        format,
      };
  return (
    // <div className={styles.yearPicker} style={style}>
    //   {defaultValue || 2023}
    // </div>

    <PickerLayout>
      <div ref={box}>
        {!isRange && (
          <DatePicker
            locale={locale}
            allowClear={false}
            // placement={placement}
            value={dayjs(defaultValue)}
            defaultValue={dayjs(defaultValue)}
            style={{ width: 100, ...style }}
            getPopupContainer={() => box.current!}
            placeholder={placeholder || "请选择"}
            onChange={onChange}
            {...pickerProps}
          />
        )}
        {isRange && (
          <RangePicker
            allowClear={false}
            picker="year"
            defaultValue={[dayjs(defaultValues[0]), dayjs(defaultValues[1])]}
            defaultPickerValue={[
              dayjs(defaultValues[0]),
              dayjs(defaultValues[1]),
            ]}
            // @ts-ignore
            onChange={onChange}
          />
        )}
      </div>
    </PickerLayout>
  );
};

export default YearPicker;
